/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs */

const en_shortcut_keys_name_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position Bottom Center`)
};

const fr_shortcut_keys_name_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionner en bas au centre`)
};

const de_shortcut_keys_name_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position unten Mitte`)
};

const it_shortcut_keys_name_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione in basso al centro`)
};

const ru_shortcut_keys_name_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Положение: Нижний центр`)
};

const es_shortcut_keys_name_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posición inferior central`)
};

const zh_cn2_shortcut_keys_name_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置：底部中心`)
};

const ja_shortcut_keys_name_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下中央に配置する`)
};

const hi_shortcut_keys_name_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति: निचला केंद्र`)
};

const pt_pt2_shortcut_keys_name_cc_position_bottom_center = /** @type {(inputs: Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição: Centro Inferior`)
};

/**
* | output |
* | --- |
* | "Position Bottom Center" |
*
* @param {Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cc_position_bottom_center = /** @type {((inputs?: Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Cc_Position_Bottom_CenterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_cc_position_bottom_center(inputs)
	if (locale === "de") return de_shortcut_keys_name_cc_position_bottom_center(inputs)
	if (locale === "it") return it_shortcut_keys_name_cc_position_bottom_center(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_cc_position_bottom_center(inputs)
	if (locale === "es") return es_shortcut_keys_name_cc_position_bottom_center(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_cc_position_bottom_center(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_cc_position_bottom_center(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_cc_position_bottom_center(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_cc_position_bottom_center(inputs)
	return en_shortcut_keys_name_cc_position_bottom_center(inputs)
});